// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__2u_gP","balanceDisclaimer":"posDashboard_balanceDisclaimer__290D1"};